// features/auth/hooks.js
import { useMutation } from "@tanstack/react-query";
import { loginApi } from "./api";
import { useAuth } from "./AuthContext";

export const useLogin = (options) => {
  const { login } = useAuth();

  return useMutation({
    mutationFn: loginApi,
    onSuccess: (res) => {
      // Supports both:
      // 1) { user, token }
      // 2) { data: { user, token } }
      const payload = res?.data?.token ? res.data : res?.data?.data;
      if (payload?.token && payload?.user) {
        login(payload);
        options?.onSuccess?.();
      }
    },
  });
};